import { render, staticRenderFns } from "./InputPosition.vue?vue&type=template&id=61c8938a&scoped=true&"
import script from "./InputPosition.vue?vue&type=script&lang=js&"
export * from "./InputPosition.vue?vue&type=script&lang=js&"
import style0 from "./InputPosition.vue?vue&type=style&index=0&id=61c8938a&scoped=true&lang=css&"
import style1 from "./InputPosition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8938a",
  null
  
)

export default component.exports